import React from 'react';
import { SvgComponentProps } from './svg-type';

export default function DecomissionedSvg({
  height = 59,
  width = 33,
  color = '#B3B3B3',
}: SvgComponentProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 13.9L13.9 15.8C14.1 15.9833 14.3377 16.075 14.613 16.075C14.8877 16.075 15.1167 15.9833 15.3 15.8C15.5 15.6 15.6 15.3623 15.6 15.087C15.6 14.8123 15.5 14.5833 15.3 14.4L13.4 12.5L15.3 10.6C15.5 10.4 15.6 10.1623 15.6 9.887C15.6 9.61233 15.5 9.38333 15.3 9.2C15.1167 9 14.8877 8.9 14.613 8.9C14.3377 8.9 14.1 9 13.9 9.2L12 11.1L10.1 9.2C9.91667 9 9.68767 8.9 9.413 8.9C9.13767 8.9 8.9 9 8.7 9.2C8.51667 9.38333 8.425 9.61233 8.425 9.887C8.425 10.1623 8.51667 10.4 8.7 10.6L10.6 12.5L8.7 14.4C8.51667 14.5833 8.425 14.8123 8.425 15.087C8.425 15.3623 8.51667 15.6 8.7 15.8C8.9 15.9833 9.13767 16.075 9.413 16.075C9.68767 16.075 9.91667 15.9833 10.1 15.8L12 13.9ZM7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.196 20.021 5 19.55 5 19V6C4.71667 6 4.479 5.90433 4.287 5.713C4.09567 5.521 4 5.28333 4 5C4 4.71667 4.09567 4.479 4.287 4.287C4.479 4.09567 4.71667 4 5 4H9C9 3.71667 9.096 3.479 9.288 3.287C9.47933 3.09567 9.71667 3 10 3H14C14.2833 3 14.521 3.09567 14.713 3.287C14.9043 3.479 15 3.71667 15 4H19C19.2833 4 19.5207 4.09567 19.712 4.287C19.904 4.479 20 4.71667 20 5C20 5.28333 19.904 5.521 19.712 5.713C19.5207 5.90433 19.2833 6 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.021 20.8043 17.55 21 17 21H7Z"
        fill="#DE4444"
      />
    </svg>
  );
}
